import { type PartialPropsOf, type PropsOf } from '@blaze-runtime/engine-domain';
import {
  type TableColumnFormat,
  type TextInputFormatDeprecated,
} from '@blaze-shared/elements-domain';

import { migrateFontBoldStyleToFontWeightMutably } from '../../../services/compat/migration.helpers';
import { type PropsMigration } from '../../../services/compat/migrations/layout-migration.models';
import { TextInputPropsBuilder } from '../text-input.props-builder';

const textInputFormatToTableFormatMap: Record<TextInputFormatDeprecated, TableColumnFormat> = {
  Text: 'text',
  Multiline: 'paragraph',
  Number: 'number',
  Percent: 'percentage',
  Percentage: 'percentage',
  Currency: 'currency',
  Email: 'email',
};

export const textInputV2Migration: PropsMigration = {
  mode: 'props',
  description:
    'Migrate Text Input element to v2 by changing font style bold to font weight and migrating format to table column format',
  run: (props: PartialPropsOf<'textInput'>): void => {
    const textInputProps = props;

    /**
     * Text Input format migration from its own to {@link TableColumnFormat}
     */
    if (textInputProps?.content?.input?.format) {
      const currentFormat = textInputProps.content.input.format;
      textInputProps.content.input.format =
        textInputFormatToTableFormatMap[currentFormat as TextInputFormatDeprecated] ||
        currentFormat ||
        'text';
    }
    updateAlignmentModelMutably(textInputProps);
    migrateFontBoldStyleToFontWeightMutably(textInputProps?.style?.inputFont);

    /**
     * This migration allows setting border and background for read-only a textInput element.
     * Task BL-7924
     */
    props.version ??= 1;
    if (props.version < 2 && props.content?.input?.readonly) {
      const pb = new TextInputPropsBuilder(textInputProps);
      const patched = pb.setReadonly(true).build() as PropsOf<'textInput'> | undefined;
      if (patched) {
        patched.version = 2;
        Object.assign(props, patched);
      }
    }
  },
};

const updateAlignmentModelMutably = (props: any): void => {
  if (typeof props.content?.title?.align === 'string') {
    props.content.title.align = { horizontal: props.content.title.align };
  }
};
